import { FC } from 'react'
import { StatusPill } from 'components/ui/StatusPill/StatusPill'
import { IAlertListRow } from 'types/ui/alertListRow.interface'
import { PillHit, Row, RowMeta, RowText, RowTitle } from './AlertListRow.styled'

export const AlertListRow: FC<IAlertListRow> = ({
  title,
  meta,
  pillLabel,
  pillTone = 'neutral',
  onClick,
  onPillClick,
}) => {
  return (
    <Row $clickable={Boolean(onClick)} onClick={onClick}>
      <RowText>
        <RowTitle>{title}</RowTitle>
        {meta && <RowMeta>{meta}</RowMeta>}
      </RowText>
      {pillLabel &&
        (onPillClick ? (
          <PillHit
            type='button'
            onClick={(e) => {
              e.stopPropagation()
              onPillClick()
            }}
          >
            <StatusPill status={pillTone}>{pillLabel}</StatusPill>
          </PillHit>
        ) : (
          <StatusPill status={pillTone}>{pillLabel}</StatusPill>
        ))}
    </Row>
  )
}
